import useDesignTokens from '@assetron/web-common/themes/useDesignTokens';
import { useTheme } from '@mui/material';
import { useMemo } from 'react';

const useSignUpDetailsStyles = () => {
  const theme = useTheme();
  const tokens = useDesignTokens();

  const styles = useMemo(
    () => ({
      formBox: {
        flex: 1,
        paddingTop: theme.sizeGuide['4xl'],
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        [theme.breakpoints.down('sm')]: {
          width: '100%',
        },
      },
      formHeadingBox: {
        width: '360px',
        display: 'flex',
        flexDirection: 'column',
        gap: theme.sizeGuide.lg,
        justifyContent: 'space-between',
        alignItems: 'center',
        paddingBottom: theme.sizeGuide['4xl'],
        [theme.breakpoints.down('sm')]: {
          gap: theme.sizeGuide.sm,
        },
      },
      subheading: {
        color: tokens.colors.text.secondary,
        textAlign: 'center',
        width: '100%',
      },
      form: {
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        gap: theme.sizeGuide['3xl'],
        [theme.breakpoints.down('sm')]: {
          width: '100%',
        },
      },
      input: {
        '& .MuiFormLabel-root': {
          fontSize: theme.typography.body_14_regular.fontSize,
        },
        '& .MuiOutlinedInput-root': {
          fontSize: '14px',
          borderRadius: theme.sizeGuide.xs,
          '& .MuiOutlinedInput-input': {
            height: `${theme.sizeGuide['3xl']} !important`,
            lineHeight: `${theme.sizeGuide['3xl']} !important`,
            padding: `${theme.sizeGuide.md} ${theme.sizeGuide.lg}`,
          },
        },
        [theme.breakpoints.down('sm')]: {
          '& .MuiOutlinedInput-root': {
            borderRadius: theme.sizeGuide.xs,
            '& .MuiOutlinedInput-input': {
              height: `${theme.sizeGuide['3xl']} !important`,
              lineHeight: `${theme.sizeGuide['3xl']} !important`,
              padding: `${theme.sizeGuide.md} ${theme.sizeGuide.lg}`,
            },
          },
        },
      },
      autocompleteInputRoot: {
        fontSize: '14px',
        '& .MuiOutlinedInput-root': {
          borderRadius: theme.sizeGuide.xs,
          '& .MuiOutlinedInput-input': {
            padding: theme.sizeGuide.xl,
          },
          '& .MuiSvgIcon-root ': {
            color: tokens.colors.text.secondary,
          },
        },
        '& .MuiAutocomplete-inputRoot': {
          padding: `${theme.sizeGuide.none} !important`,
        },
      },
      inputContainerBox: {
        display: 'flex',
        flex: 1,
        flexDirection: 'column',
        alignItems: 'center',
        gap: theme.sizeGuide['2xl'],
        width: '360px',
        [theme.breakpoints.down('sm')]: {
          width: '100%',
        },
      },
      button: {
        paddingBottom: theme.sizeGuide['4xl'],
        display: 'flex',
        flexDirection: 'column',
        gap: theme.sizeGuide.xl,
        textAlign: 'center',
        width: '360px',
        [theme.breakpoints.down('sm')]: {
          width: '100%',
          paddingBottom: theme.sizeGuide.none,
        },
      },
      dropdownOption: {
        display: 'flex',
        flexDirection: 'row',
        padding: theme.sizeGuide.none,
        width: '100%',
        justifyContent: 'center',
        gap: theme.sizeGuide.md,
        minHeight: `${theme.sizeGuide['4xl']} !important`,
      },
      listBox: {
        style: {
          maxHeight: '246px',
        },
        sx: {
          backgroundColor: tokens.colors.bg.primary,
          boxShadow: theme.customShadows.buttonShadowXL,
          '&::-webkit-scrollbar': {
            width: theme.sizeGuide.md,
          },
          '&::-webkit-scrollbar-track': {
            background: tokens.colors.bg.primary,
          },
          '&::-webkit-scrollbar-thumb': {
            backgroundColor: tokens.components.scrollbar.bg,
            borderRadius: tokens.radius.xs,
            ':hover': {
              backgroundColor: tokens.components.scrollbar.bg_hover,
            },
          },
        },
        position: 'bottom-start',
      },
      dropdownIcon: {
        color: tokens.colors.text.secondary,
      },
      dropdownLabel: {
        flex: 1,
        [theme.breakpoints.down('sm')]: {
          padding: theme.sizeGuide.none,
        },
      },
      nextButtonText: {
        paddingTop: theme.sizeGuide.lg,
        paddingBottom: theme.sizeGuide.lg,
        textTransform: 'Capitalize',
      },
      inputLabel: {
        display: 'flex',
        justifyContent: 'start',
        textAlign: 'start',
      },
      gdprText: {
        alignSelf: 'center',
        color: tokens.colors.text.secondary,
      },
    }),
    [theme, tokens],
  );

  return styles;
};

export default useSignUpDetailsStyles;
